export default __webpack_public_path__ + "8a5f11b601d252692555786555a7e397.png";